<template>
    <div>
        
        <OnlineRenewalThankYou :policy-number="policyNumber"
        v-if="paymentSuccess"/>
        
    </div>
</template>

<script>
import OnlineRenewalThankYou from '@/components/OnlineRenewalThankYou.vue'

export default {
    data() {
        return {
            paymentSuccess: false,
        }
    },
    components: {
        OnlineRenewalThankYou
    },
    computed: {
        policyNumber() {
            return this.$store.state.sessionDetails === null ? null : this.$store.state.sessionDetails.properties.policy_no;
        },
      fetchSessionDetailsPayload() {
            return {
                method: 'get',
                url: `${this.baseURL}/api/cfa/get_cfa_session_for_elantis_by_reference_id.json`,
                params: {
                    target: 'session_by_reference_id',
                    id: this.$store.state.onlineRenewalQuoteReferenceId,
                    token: document.getElementsByName('cmb-api-token')[0].content,
                    token_name: 'cmb-auth'
                }
            }
        },
        fetchQuoteDetailsPayload() {
            return {
                method: 'get',
                url: `${this.baseURL}/main/get.json`,
                params: {
                    target: 'quote_by_session_id',
                    session_id: this.$store.state.sessionDetails.id,
                    token: document.getElementsByName('cmb-api-token')[0].content,
                    token_name: 'cmb-auth'
                }
            }
        },
        fetchPreviousPolicyDetailsPayload() {
            return {
                method: 'get',
                url: `${this.baseURL}/main/get_policies_by_policy_id.json`,
                params: {
                    id: this.$store.state.sessionDetails.properties.previous_policy_id,
                    token: document.getElementsByName('cmb-api-token')[0].content,
                    token_name: 'cmb-auth'
                }
            }
        },
        fetchCompanyDetailsPayload() {
            return {
                method: 'get',
                url: `${this.baseURL}/main/get_company.json`,
                params: {
                    id: this.$store.state.previousPolicyDetails.properties.company_id,
                    token: document.getElementsByName('cmb-api-token')[0].content,
                    token_name: 'cmb-auth'
                }
            }   
        },
    },
    methods: {
        async fetchSessionDetails() {
            let response = await this.$store.dispatch('fetchData', this.fetchSessionDetailsPayload);
            if(response.data.items.total_entries > 0) {
                this.$store.state.sessionDetails = response.data.items.results[0];
                this.$store.commit('mutate', {
                    property: 'sessionDetails',
                    value: response.data.items.results[0]
                })
                this.fetchQuoteDetails();
            } else {
                this.paymentSuccess = true;
            }
        },
        async fetchQuoteDetails() {
            let response = await this.$store.dispatch('fetchData', this.fetchQuoteDetailsPayload);
            if(response.data.items.total_entries > 0) {
                this.$store.commit('mutate', {
                    property: 'quoteDetails',
                    value: response.data.items.results[0]
                })
                this.fetchPreviousPolicyDetails();
            }
        },
        async fetchPreviousPolicyDetails() {
            let response = await this.$store.dispatch('fetchData', this.fetchPreviousPolicyDetailsPayload);
            if(response.data.items.total_entries > 0) {
                this.$store.commit('mutate', {
                    property: 'previousPolicyDetails',
                    value: response.data.items.results[0]
                })
                this.$store.commit('mutate', {
                    property: 'onlineRenewalPaymentTerms',
                    value: this.$store.state.previousPolicyDetails.properties.payment_terms
                });
                this.fetchCompanyDetails();
            }
        },
        async fetchCompanyDetails() {
            let response = await this.$store.dispatch('fetchData', this.fetchCompanyDetailsPayload)
            if(response.data.items.total_entries > 0) {
                this.$store.commit('mutate', {
                    property: 'companyDetails',
                    value: response.data.items.results[0]
                })
                this.createElantisOrderAndPayment();
            }
        },
        async createElantisOrderAndPayment() {

            let data = {
                token: document.getElementsByName('cmb-api-token')[0].content,
                token_name: "cmb-auth",
                transactions_api_token: this.transactionsAPIToken,
                payment_source: "elantis",
                base_url: this.baseURL,
                type: "quick_quote",
                session_id: this.$store.state.sessionDetails.id,
                quote_id: this.$store.state.quoteDetails.id,
                description: `${this.$store.state.sessionDetails.id}-${this.$store.state.quoteDetails.id}`,
                user_type: this.$store.state.sessionDetails.properties.user_type,
                env: this.environment,
                business_name:  this.$store.state.sessionDetails.business_name,
                user_id: this.$store.state.sessionDetails.user_id,
                start_date : this.$store.state.sessionDetails.properties.policy_start,
                end_date : this.$store.state.sessionDetails.properties.policy_expiry
            },
            payload = {
                method: 'post',
                url: `${this.baseURL}/api/fdca/quote/create-order-and-payment.json`,
                data: data
            },
            createOrderAndPaymentResponse = await this.$store.dispatch('fetchData', payload);
            if(createOrderAndPaymentResponse.data.api_call_send.errors.length === 0) {
                this.updateSessionStatusToClosed();
            }
        },
        async updateSessionStatusToClosed() {
            let updateSessionStatusPayload = {
                method: 'put',
                url: `${this.baseURL}/api/cfa/update_session_status.json`,
                data: {
                    id: this.$store.state.sessionDetails.id,
                    session_status: 'closed'
                }
            },
            updateSessionStatusResponse = await this.$store.dispatch('fetchData', updateSessionStatusPayload);
            this.paymentSuccess = true;
        }
    },
    mounted() {
        this.$store.commit('mutate', {
            property: "onlineRenewalQuoteReferenceId",
            value: this.$route.params.quote_reference_id
        });
        this.fetchSessionDetails();
    }
}
</script>

<style scoped>
</style>


